





































import Vue from 'vue';
import CustomerGroupEditBox from './CustomerGroupEditBox.vue';
import RiskBox from '../../../common/components/ui/RiskBox/index.vue';
import customerClient from '../../../customer/apis';
import customerVuex from '../../../customer/vuex/common';
import commonClient from '../../../common/apis';
import { TaskType } from '../../../common/models/TaskType';

export default Vue.extend({
  mixins: [customerVuex],
  props: {
    group: {
      type: Object,
      default: null,
    },
    openids: {
      type: Array as () => number[],
      default: [],
    },
    isBatch: {
      type: Boolean,
      default: false,
    },
    initIds: {
      type: Array as () => number[],
      default: [],
    },
  },
  components: {
    CustomerGroupEditBox,
    RiskBox,
  },
  data() {
    return {
      showEdit: false,
      showDelete: false,
      batchAppendGroupIng: false,
      selectedIds: [],
    };
  },
  methods: {
    updateGroup(groupName: string) {
      customerClient.updateGroup({id: this.group.group.id, name: groupName}).success((r) => {
        if (r) {
          this.$Message.success('修改成功');
          this.showEdit = false;
          this.$emit('success');
        }
      });
    },
    appendGroup(group: any) {
      if (group.selected) {
        if (this.openids.length > 0 && this.openids.length < 30) {
          if (!this.batchAppendGroupIng) {
            this.batchAppendGroupIng = true;
            customerClient.batchAppendGroup({
              openids: this.openids,
              groupId: group['group']['id']}).success((r) => {
              if (r && r.failure === 0 ) {
                this.$Message.success('添加到组成功');
                if (!this.isBatch) {
                  this.selectedIds.push(group['group']['id']);
                  this.$store.commit('UPDATE_CUSTOMER_PROP', {
                    openid: this.openids[0],
                    key: 'groups',
                    value: this.selectedIds,
                    builtIn: true,
                  });
                }
              }
              if (r && r.failure > 0 ) {
                this.$Message.success('添加到组成功：' + r.success + '人， 失败：' + r.failure + '人');
              }
              this.$emit('success');
              this.batchAppendGroupIng = false;
            }).error(() => {
              this.batchAppendGroupIng = false;
            });
          } else {
            this.$Message.warning('有分组任务未完成，请稍后再试');
          }
        } else {
          this.$emit('appendGroup', group.group.id, group.selected);
        }
      } else if (!group.selected && !this.isBatch) {
        customerClient.removeGroup({
          openid: this.openids[0],
          groupId: group['group']['id']}).success((r) => {
          this.selectedIds.splice(this.selectedIds.indexOf(group['group']['id']), 1);
          this.$store.commit('UPDATE_CUSTOMER_PROP', {
            openid: this.openids[0],
            key: 'groups',
            value: this.selectedIds,
            builtIn: true,
          });
          this.$Message.success('移除成功');
          this.$emit('success');
        });
      } else {}
    },
    deleteGroup() {
      if (this.group['group']['count'] <= 50) {
        if (!this.batchAppendGroupIng) {
          this.batchAppendGroupIng = true;
          customerClient.batchRemoveGroup({groupId: this.group.group.id, size: 50}).success((r) => {
            if (r) {
              this.$Message.success('删除成功');
            }
            this.$emit('success');
            this.showDelete = false;
            this.batchAppendGroupIng = false;
          }).error(() => {
            this.batchAppendGroupIng = false;
          });
        } else {
          this.$Message.warning('有分组任务未完成，请稍后再试');
        }
      } else {
        this.createDeleteTask();
      }
    },
    createDeleteTask() {
      commonClient.createTask({
        input: {
          GroupRemove: {
            groupId: this.group.group.id,
          },
        },
        taskType: TaskType.GroupRemove,
        expectCount: this.group.group.count,
      }).success((r: any) => {
        this.$Message.success('创建删除组任务成功，请等待完成');
        this.showDelete = false;
        this.$emit('close');
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
  mounted() {
    this.selectedIds = this.initIds;
  },
});
